import { Component, OnInit, ViewChild } from '@angular/core';
import { HtmlTemplateVar } from '../../../../../dto/templates/html-template-var';
import { HtmlEditorComponent } from '../../../../../shared/html-editor/html-editor.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EmailTemplate } from '../../../../../dto/templates/email-template';
import { HtmlTemplate } from '../../../../../dto/templates/html-template';
import { OtherTemplatesService } from '../../../../services/other-templates.service';
import { TemplatesNames } from '../../../../../dto/docs-names';
import {LocationStrategy} from '@angular/common';


@Component({
  selector: 'app-other-templates-edit',
  templateUrl: './other-templates-edit.component.html',
  styleUrls: ['./other-templates-edit.component.css']
})
export class OtherTemplatesEditComponent implements OnInit {
  name: string;
  templateForm: FormGroup;
  templatesNames = TemplatesNames;
  docName: string;
  @ViewChild(HtmlEditorComponent, { static: false }) editor: HtmlEditorComponent;
  externalUrlPreview: string;
  constructor(
    private templatesService: OtherTemplatesService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private locationStrategy: LocationStrategy,
  ) { }

  ngOnInit() {
    this.name = this.route.snapshot.paramMap.get('name');
    this.externalUrlPreview = this.getExternalUrl(this.name);
      this.templatesService.getForEdit(this.name).subscribe(result => {
        this.initForm(result);
        this.docName = this.templatesNames[this.name];
        this.documentName = result.documentName;
      });
  }

  getExternalUrl(templateName: string) {
    // TODO dont hardcode
    return 'https://cardbro.cardcompact.com' + this.locationStrategy.prepareExternalUrl('/documents/' + templateName);
  }

  initForm( template: HtmlTemplate ) {
    this.templateForm = this.formBuilder.group( {
      html: template.html,
      mjml: template.mjml,
      documentName: template.documentName,
    } );
  }

  goBack() {
    this.router.navigate(['../..'], {relativeTo: this.route}).then();
  }

  onSubmit( form: FormGroup ) {
      this.templatesService.update( this.name, form.value ).subscribe( res => this.goBack() );
  }


  isEditingDocName = false;
  documentName = '';

  setEditingDocumentName() {
    this.isEditingDocName = true;
  }
}
